// React
import React, { useState, useContext } from "react";

// Material-UI (Core)
import { Button, AppBar, Drawer, IconButton, Link, List, Toolbar, Typography } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Libraries
import { useObserver } from "mobx-react-lite";
import styled from "styled-components";

// Core
import { useMediaQuery } from "Core/Utils/Media";

// Custom
import { StoresContext, Stores } from "Custom/Stores";
import { GridSpaced } from "Custom/StylesAppSpecific/GridHelperStyling";
import { HeaderViewModel } from "Custom/ViewModels/HeaderViewModel";
import { HeaderLogoModel } from "Custom/ViewModels/DashboardSubViewModels/HeaderLogoModel";
import { getSuperAdminBarHeight } from "Custom/Components/SuperAdminNotificationBar";

const StyledIconButton = styled(IconButton)`
    padding: 0;
    color: white;
`;
const MainHeader = styled(AppBar)`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    button svg {
        fill: #3c3c3b;
    }
    @media only screen and (max-width: 960px) {
        & > div {
            justify-content: center;
            & > div:last-child {
                margin: 0;
                position: absolute;
                right: 20px;
                top: 0;
                z-index: 2;
            }
        }
    }
`;

const DrawerList = styled(List)`
    button,
    a {
        width: 100%;
    }

    .MuiTypography-root {
        text-align: center;
        color: white;
        font-weight: bold;
    }
`;

export const Header: React.FC = () => {
    // #region Code Behind

    const isMobile = !!useMediaQuery("screen and (max-width: 767px)");
    const storesContext = useContext<Stores>(StoresContext);

    const [viewModel] = useState(() => new HeaderViewModel());
    const [ViewModels] = useState(() => new HeaderLogoModel());
    const [open, setOpen] = useState(false);
    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => setOpen(false);

    // #endregion Code Behind

    const headerOptions = () => {
        return (
            <>
                <Button style={{ background: "#3C3C3B", padding: "8px 20px" }}>
                    <Link onClick={viewModel.logout}>
                        <Typography style={{ color: "#FFF" }} variant={"button"}>
                            Logout
                        </Typography>
                    </Link>
                </Button>
            </>
        );
    };

    return useObserver(() => (
        <>
            {storesContext.domain.AccountStore.IsLoggedIn ? (
                <>
                    <MainHeader position="fixed" style={{ top: getSuperAdminBarHeight(), transition: "top 0.2s ease-in-out" }}>
                        <Toolbar style={{ maxHeight: "50px", minHeight: "50px" }}>
                            {storesContext.domain.AccountStore.IsLoggedIn ? (
                                <>
                                    <div onClick={ViewModels.handleNavBarLogoClick} style={{ cursor: "pointer" }}>
                                        {ViewModels.canDisplayCompanyLogo ? (
                                            <img src={ViewModels.companyLogo} alt="Company Logo" style={{ maxHeight: "40px", maxWidth: isMobile ? "120px" : "200px" }} />
                                        ) : (
                                            <img src="resources/logo-dark.svg" alt="Customer Portal Logo" style={{ marginLeft: "10px" }} />
                                        )}
                                    </div>
                                    <GridSpaced item margin={"0 0 0 auto"} padding={"10px 0px"}>
                                        <StyledIconButton aria-label="Open drawer" color="primary" onClick={handleDrawerOpen}>
                                            <MenuIcon />
                                        </StyledIconButton>
                                    </GridSpaced>
                                </>
                            ) : (
                                <></>
                            )}
                        </Toolbar>
                    </MainHeader>
                    <Drawer anchor="right" onClose={handleDrawerClose} open={open} PaperProps={{ style: { backgroundColor: "#fff", padding: "10px" } }}>
                        <div style={{ display: "block", height: "42px", padding: "0px" }}>
                            <IconButton onClick={handleDrawerClose} style={{ display: "block", height: "100%", padding: "0px", marginLeft: "auto", background: "transparent" }}>
                                <ArrowBackIcon style={{ color: "#3C3C3B" }} />
                            </IconButton>
                        </div>
                        <DrawerList>{headerOptions()}</DrawerList>
                    </Drawer>
                </>
            ) : (
                <></>
            )}
        </>
    ));
};
